if (!customElements.get('all-destinations-menu')) {
  customElements.define(
    'all-destinations-menu',
    class extends HTMLElement {
      constructor() {
        super();

        this.allDestinationsButton = this.querySelector('#sidebar__all-destinations-link');
        this.inner = this.querySelector('.mobile-sidebar__inner');
        this.allDestinationsMenu = this.querySelector('.all-destinations__container.in-sidebar');
        this.backBtn = this.querySelector('.destinations__back-btn');
      }

      showAllDestinations() {
        console.log('Show All Destinations menu');

        if (!this.allDestinationsMenu || !this.inner) return;

        this.allDestinationsMenu.classList.add('active');
        this.inner.classList.add('hidden');
      }

      hideAllDestinations() {
        if (!this.allDestinationsMenu || !this.inner) return;

        this.allDestinationsMenu.classList.remove('active');
        this.inner.classList.remove('hidden');
      }

      connectedCallback() {
        const init = () => {

          this.inSidebar = this.closest('.mobile-sidebar') !== null;

          if (this.inSidebar && window.__dropdownNavSource === 'VWO') {
            this.dropdownNavTest();
          } else {
            // this.querySelector('#sidebar__all-destinations-link')?.remove();
          }

          if (this.allDestinationsButton) {
            this.allDestinationsButton.addEventListener(
              'click',
              this.showAllDestinations.bind(this),
            );
          }

          if (this.backBtn) {
            this.backBtn.addEventListener('click', this.hideAllDestinations.bind(this));
          }
        };

        this.initCallback = init;
        document.readyState === 'loading'
          ? document.addEventListener('DOMContentLoaded', this.initCallback)
          : init();
      }

      dropdownNavTest() {
        console.log('Running sidebar nav test');
        this.classList.add('sidebar-nav-test');

        const helpIcon = this.querySelector('.mobile-sidebar__footer-icon');
        const helpText = this.querySelector('.mobile-sidebar__footer-text');

        if (helpIcon) {
          helpIcon.innerHTML = `<svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
          >
            <path
              d="M7.715 7.625C7.9501 6.95667 8.41415 6.39311 9.02495 6.03413C9.63576 5.67516 10.3539 5.54394 11.0522 5.66371C11.7505 5.78349 12.3838 6.14652 12.8401 6.68853C13.2963 7.23053 13.5461 7.91652 13.545 8.625C13.545 10.625 10.545 11.625 10.545 11.625M10.625 15.625H10.635M20.625 10.625C20.625 16.1478 16.1478 20.625 10.625 20.625C5.10215 20.625 0.625 16.1478 0.625 10.625C0.625 5.10215 5.10215 0.625 10.625 0.625C16.1478 0.625 20.625 5.10215 20.625 10.625Z"
              stroke="#0C1924"
              stroke-width="1.25"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>`;
        }

        if (helpText) {
          helpText.innerText = 'Help';
        }

        this.querySelector('button[data-target="popular"]')?.remove();
        this.querySelector('.all__destinations-link-default')?.remove();

        const banner = this.querySelector('.mobile-sidebar__banner');
        const footer = this.querySelector('.mobile-sidebar__footer');

        if (banner && footer) {
          banner.before(footer);
        }
      }

      disconnectedCallback() {
        this.allDestinationsButton?.removeEventListener(
          'click',
          this.showAllDestinations.bind(this),
        );
        this.backBtn?.removeEventListener('click', this.hideAllDestinations.bind(this));

        if (this.initCallback) {
          document.removeEventListener('DOMContentLoaded', this.initCallback);
        }
      }
    },
  );
}
